import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import get from 'lodash/get';
import {palette} from '../../../theme/palette';

import { ReactComponent as DeleteIcon } from '../../../assets/icons/main/delete-icon.svg';
import { useTheme } from '@emotion/react';
import { lighten } from '@mui/material';
import lightOrdarkColor from '@check-light-or-dark/color';

type RowDataType = { id: number; key: string; value: string };

const TagsTable = ({ tags, setTags, ajvErrors, readOnly }: any) => {
  const theme :any = useTheme();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, rowId: string | number) => {
    const { name, value } = e.target;

    const updatedTags = tags.map((tag: RowDataType) => {
      if (tag.id === rowId) {
        return {
          ...tag,
          [name]: value,
        };
      }
      return tag;
    });

    setTags(updatedTags);
  };

  return tags.length ? (
    tags.map(({ id, key, value }: { id: number; key: string; value: string }, idx: number) => (
      <Grid
        key={id}
        container
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: '16px 32px',
          backgroundColor: idx % 2 === 0 ? '' : `${lightOrdarkColor(theme.palette.background.default) === 'dark' ?  lighten(theme.palette.background.default,0.05)  :  lighten(theme.palette.background.default,0.9)}`,
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        }}
        columnSpacing={4}
      >
        <Grid item xs={6} md={3}>
          <TextField
            type='text'
            margin='normal'
            fullWidth
            id='key'
            name='key'
            autoComplete='key'
            variant='outlined'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, id)}
            value={key}
            disabled={readOnly}
            size='small'
            sx={{ margin: 0 }}
            helperText={get(ajvErrors, 'instancePath', '').includes(`${idx}/key`) && ajvErrors.message}
            error={get(ajvErrors, 'instancePath', '').includes(`${idx}/key`)}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            type='text'
            margin='normal'
            fullWidth
            id='value'
            name='value'
            autoComplete='value'
            variant='outlined'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, id)}
            value={value}
            disabled={readOnly}
            size='small'
            sx={{ margin: 0 }}
            helperText={get(ajvErrors, 'instancePath', '').includes(`${idx}/value`) && ajvErrors.message}
            error={get(ajvErrors, 'instancePath', '').includes(`${idx}/value`)}
          />
        </Grid>
        {(!readOnly && idx !== 0) && <Grid item xs={2} md={1}>
          <IconButton
            onClick={() => {
              const updatedTags = tags.filter((tag: any) => tag.id !== id);
              setTags(updatedTags);
            }}
          >
            <DeleteIcon style={{color: theme.palette.custom.light}} />
          </IconButton>
        </Grid>}
      </Grid>
    ))
  ) : (
    <>
      <Grid
        container
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: '16px 32px',
          backgroundColor: palette.primary.contrastText,
        }}
        columnSpacing={4}
      >
        <Grid item xs={12} md={3}>
          <Typography sx={{ fontWeight: 600, fontSize: '16px', textAlign: 'center', ml: 4 }}>No Tags</Typography>
        </Grid>
      </Grid>
      <Divider />
    </>
  );
};

export default TagsTable;
